// src/services/staffService.js
import { tenantDataService } from './tenantDataService';
const COLLECTION_NAME = 'staff';

/**
 * Retrieve the staff list from Firebase or localStorage
 * @returns {Promise<Array<{ id: string; name: string; role: string; }>>}
 */
export async function getStaff() {
  try {
    const staff = await tenantDataService.getAll(COLLECTION_NAME);
    return Array.isArray(staff) ? staff : [];
  } catch (e) {
    console.error('Error loading staff:', e);
    return [];
  }
}

/**
 * Save a staff member to Firebase or localStorage
 * @param {Object} staffMember
 * @returns {Promise<Object>} The saved staff member with ID
 */
export async function saveStaff(staffMember) {
  try {
    // Standardize the data structure to ensure consistent name fields
    const standardizedStaff = {
      ...staffMember,
      // Ensure 'name' field always exists using fallback logic
      name: staffMember.name || 
            staffMember.displayName || 
            staffMember.fullName || 
            `${staffMember.firstName || ''} ${staffMember.lastName || ''}`.trim() || 
            staffMember.email || 
            'Unnamed Staff'
    };

    if (staffMember.id) {
      // Update existing
      return await tenantDataService.update(COLLECTION_NAME, staffMember.id, standardizedStaff);
    } else {
      // Create new
      const result = await tenantDataService.create(COLLECTION_NAME, standardizedStaff);
      return result;
    }
  } catch (e) {
    console.error('Error saving staff:', e);
    throw e;
  }
}

/**
 * Delete a staff member
 * @param {string} id
 */
export async function deleteStaff(id) {
  try {
    return await tenantDataService.delete(COLLECTION_NAME, id);
  } catch (e) {
    console.error('Error deleting staff:', e);
    throw e;
  }
}
